import {renderCellDate} from "../../../../utils/table-render-functions"

export const COLUMNS_MODAL_TABLE_CETIP_ISIN = [
    { field: "CETIP", headerName: "CETIP", minWidth: 130 },
    { field: "ISIN", headerName: "ISIN", minWidth: 130 },
    { field: "TipoAtivo", headerName: "Tipo Ativo", minWidth: 100 },
    { field: "Devedor", headerName: "Devedor", flex: 1 },
    { field: "DataResgateAntecipado", headerName: "Data Resgate Antecipado", maxWidth: 180, flex: 1, renderCell: (params) => renderCellDate(params) },
    { field: "Vencimento", headerName: "Data Vencimento", maxWidth: 180, flex: 1, renderCell: (params) => renderCellDate(params) },
]

export const INITIAL_STATE_MODAL_CETIP_ESIN = {
    selectCetipIsin: "",
    isLoadingModalData: false,
    row: [],
    listFullModalVisible: false,
    lastFetched: null,
}

export const CONFIG_MODAL_CETIP_ESIN = {
    cacheTime: 1000 * 60 * 3,
}
